export const respPX = "px-6 sm:px-6 md:px-8 lg:px-10 xl:px-12";
